exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rotator-3-wrapper[data-v-64e9584c]{width:auto;max-width:410px;padding-bottom:10px}", ""]);

// exports
